import sortBy from 'lodash-es/sortBy';
import type { ProductVariant, ProductVariantAttribute } from '../bff-api/products/model';

type VariationValues = ProductVariant['variationValues'];

const variationTypes = ['colorName', 'size', 'color', 'gcDesign'];
const variationTypeToVariationAttributeMap: Record<keyof VariationValues, string> = {
    colorName: 'color',
    size: 'size',
    color: 'color',
    isSingleSku: '',
    gcDesign: 'gcDesign',
    design: 'design',
};

export function getVariantVariationType(
    variantValues: VariationValues,
): keyof VariationValues | undefined {
    const variationTypesFound = Object.keys(variantValues)
        .filter((key): key is keyof VariationValues => variationTypes.includes(key))
        .map((variationKey) => {
            if (variationKey === 'gcDesign') {
                return 'design';
            }

            return variationKey;
        });
    const [type] = sortBy(variationTypesFound, (vt) => variationTypes.indexOf(vt));

    return type;
}

export function getVariationName(
    variantValues: VariationValues,
    variationAttributes: ProductVariantAttribute[],
): string {
    const variationType = getVariantVariationType(variantValues);

    if (!variationType) {
        return '';
    }

    const variationAttribute = variationAttributes.find(
        (attr) => attr.id === variationTypeToVariationAttributeMap[variationType],
    );

    if (!variationAttribute) {
        return variantValues[variationType] ?? '';
    }

    const variationAttr = variationAttribute.values.find(
        (value) => value.value === variantValues[variationType],
    );

    return variationAttr?.name ?? variantValues[variationType] ?? '';
}

export function getVariationValue(
    variantValues: VariationValues,
    variationAttributes: ProductVariantAttribute[],
): string {
    const variationType = getVariantVariationType(variantValues);

    if (!variationType) {
        return '';
    }

    const variationAttribute = variationAttributes.find(
        (attr) => attr.id === variationTypeToVariationAttributeMap[variationType],
    );

    if (!variationAttribute) {
        return variantValues[variationType] ?? '';
    }

    const variationAttr = variationAttribute.values.find(
        (value) => value.value === variantValues[variationType],
    );

    return variationAttr?.value ?? variantValues[variationType] ?? '';
}
